/**
 * Used by exhibitor-sheet AND product page.
 */
export default {
    init: function (utils, Drawer) {

        this.initDrawer(Drawer);
        this.initCfDrawer(Drawer);

    },

    /**
     * @function
     * @name initCfDrawer
     * @description Initialize the custom fields drawer
     * @param {Drawer} Drawer
     */
    initCfDrawer: function (Drawer) {
        const drawerEl = document.querySelector('.js-portal-cf-drawer');
        if(drawerEl) {
            const drawerInstance = new Drawer(drawerEl, {
                closeBtnCSSSelector: '.js-drawer-cf-close',
                toggleBtnCSSSelector: '.js-drawer-cf-open'
            });
        }
    },

    /**
     * @function
     * @name initDrawer
     * @description Initialize the main drawer
     * @param {Drawer} Drawer
     */
    initDrawer: function (Drawer) {
        const drawerEl = document.querySelector('.js-portal-drawer');
        if(drawerEl) {
            const drawerInstance = new Drawer(drawerEl, {
                closeBtnCSSSelector: '.js-drawer-close',
            });

            drawerInstance.on('opened', (event) => {
                const form_target = event.detail.clickedEl.dataset.form;
                const forms = document.querySelectorAll(`.js-drawerFormItem[data-form="${form_target}"]`);
                forms.forEach(form => {
                    form.classList.add('--active');
                    //Refresh wysiwyg because he's hidden by default
                    setTimeout(() => {
                        if (typeof tinymce !== 'undefined') {
                            const wysiwygTextareas = form.querySelectorAll('.acf-field-wysiwyg textarea');
                            if (wysiwygTextareas.length > 0) {
                                wysiwygTextareas.forEach(function(textarea){
                                    var id = textarea.id;
                                    if (tinymce.get(id)) {
                                        tinymce.execCommand('mceRemoveEditor', false, id);
                                    }
                                    tinymce.execCommand('mceAddEditor', false, id);
                                });
                            }
                        }
                    }, 100);
                });

            });

            drawerInstance.on('closed', (event) => {
                const forms = document.querySelectorAll(`.js-drawerFormItem`);

                forms.forEach(form => {
                    form.classList.remove('--active');
                });
            });
        }
    }
}
